import _stubFalse2 from "lodash/stubFalse";
import _isFinite2 from "lodash/isFinite";
import React from 'react';
import classnames from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Price } from 'swag-client-common/utils/price';
import { FREE } from 'swag-client-common/constants';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import fastAppearAnimationClasses from '../../../../../../animations/fast-appear.anim.scss';
import { PriceTooltip } from './components/price-tooltip';
import classes from './price-block.scss';
export const PriceBlockComponent = ({
  price,
  edgePrices,
  isBoxProduct,
  minQuantityError,
  setupFee,
  oldSetupFee,
  totalSharedSetupFee,
  isSetupFeeShown,
  priceForEachLabel,
  totalPriceLabel,
  onInfoIconClick,
  setupFeeLabel,
  openPricingFormationDetailsPopup,
  isStandaloneItem,
  isSharedInBoxItem,
  isEditingSharedOrRelatedItem,
  totalOfAssociatedPrice,
  priceWithoutSetupFee,
  totalSaveForAssociated,
  isLimitedEdition,
  rowClassName = '',
  labelClassName = '',
  valueClassName = ''
}) => {
  const totalToShow = _isFinite2(totalOfAssociatedPrice) ? totalOfAssociatedPrice : price;
  const totalFormatted = totalToShow !== 0 || isStandaloneItem ? Price.formatPrice(totalToShow) : FREE;
  return /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: fastAppearAnimationClasses,
    key: _isFinite2(price) && !minQuantityError ? price : 'price range',
    timeout: 250
  }, _isFinite2(price) && !minQuantityError && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wideRow)
  }, !_isFinite2(totalOfAssociatedPrice) && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.row, rowClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.secondaryText, classes.flex, labelClassName)
  }, /*#__PURE__*/React.createElement("span", null, priceForEachLabel)), /*#__PURE__*/React.createElement("div", {
    "data-footer": "PricePerItem",
    className: classnames(classes.emphasizedText, classes.emphasizedTextIcon, valueClassName)
  }, Price.formatPrice(priceWithoutSetupFee), isSetupFeeShown && /*#__PURE__*/React.createElement(InfoIcon, {
    onClick: isBoxProduct ? onInfoIconClick : _stubFalse2,
    className: classnames(classes.setupFeeDetails, {
      [classes.actionable]: isBoxProduct
    }),
    isLimitedEdition: isLimitedEdition
  }), /*#__PURE__*/React.createElement(PriceTooltip, {
    oldSetupFee: oldSetupFee,
    setupFee: setupFee,
    totalSharedSetupFee: totalSharedSetupFee,
    price: price,
    priceForEachLabel: priceForEachLabel,
    priceWithoutSetUpFee: priceWithoutSetupFee,
    isStandaloneItem: isStandaloneItem,
    isSharedInBoxItem: isSharedInBoxItem,
    isEditingSharedOrRelatedItem: isEditingSharedOrRelatedItem,
    setupFeeLabel: setupFeeLabel,
    isLimitedEdition: isLimitedEdition,
    classes: classes
  }))), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.row, rowClassName),
    "data-footer": "PriceTotal"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.secondaryText, classes.flex, labelClassName)
  }, totalPriceLabel, ":"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.mainText, classes.flex, {
      [classes.orange]: isLimitedEdition
    }, valueClassName)
  }, totalFormatted, ' ', _isFinite2(totalOfAssociatedPrice) && /*#__PURE__*/React.createElement(InfoIcon, {
    className: classes.pricingDetails,
    onClick: () => openPricingFormationDetailsPopup()
  }))), !!totalOfAssociatedPrice && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.row, rowClassName),
    "data-footer": "PriceTotalOfAssociated"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.secondaryText, classes.flex, labelClassName)
  }, "You save:"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.mainText, classes.flex, classes.save)
  }, Price.formatPrice(totalSaveForAssociated)))) || /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.rowMobile, classes.wideRow, rowClassName),
    "data-footer": "PriceRange"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.secondaryText, labelClassName)
  }, "Prices from:"), edgePrices && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.greyImportant, valueClassName)
  }, Price.formatPrice(edgePrices.minPrice)), Price.formatPrice(edgePrices.minPrice) !== Price.formatPrice(edgePrices.maxPrice) && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: classes.secondaryText
  }, "\xA0to\xA0"), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.greyImportant, valueClassName)
  }, Price.formatPrice(edgePrices.maxPrice)))))));
};